import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { slackApproval } from './authActions';
import { getAssisantSkills } from '../skills/skills_action';
import './auth.css';
import { message } from 'antd';
import axios from 'axios';

const team_mood_and_checkin_states = [
  'trooprai-landing',
  'website-standup',
  'website-retro',
  'website-poker',
  'trooprai-teammood',
  'trooprai-pricing',
];
class SlackAuth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
    };
  }

  async componentDidMount() {
    let _obj = {
      code: queryString.parse(this.props.location.search).code,
    };

    let url = localStorage.troopr_workspace_id_url;
    if (url) {
      _obj.workspace_id = localStorage.troopr_workspace_id_url.split('/')[2];
    }

    let Type = queryString.parse(this.props.location.search).state;
    const [type, params] = Type.split('<break>'); // OLD LOGIC => Type.split('.');
    _obj.source = type;
    if (!this.state.error) {
    }

    if (_obj.source === 'botupdate') {
      const workspace_id = localStorage.getItem('userCurrentWorkspaceId');
      const token = localStorage.getItem('token');
      if (!token) {
        window.location.href = '/troopr/access';
        return;
      } else {
        // const res = await axios.post(`/bot/api/${workspace_id}/hanldeBotUpdate`, {
        const res = await axios.post(
          `/bot/api/w/${workspace_id}/team/botUpdate`,
          {
            code: _obj.code,
          }
        );

        if (res.data.success && res.data.workspace_id) {
          window.location.href = `/${res.data.workspace_id}/dashboard?botupdate=success`;
          return;
        } else {
          this.setState({ error: 'error_botupdate' });
          return;
        }
      }
    }

    const IsJsonString = (str) => {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    };

    this.props
      .slackApproval(
        _obj,
        params && IsJsonString(params) ? JSON.parse(params) : {}
      )
      .then((response) => {
        // v2.1 onboarding (new UI at /v2): always return to the wizard so the
        // user continues where they left off. The Slack team is linked
        // server-side; the wizard re-checks connection via getChannels on mount.
        // The rest of this handler redirects into the legacy UI, which is wrong
        // for the new flow.
        if (type === 'v21_onboarding') {
          // [TROOPR-DEBUG] Temporary: trace the v2.1 Slack callback outcome.
          console.log(
            '[TROOPR-DEBUG][slackAuth v21]',
            'success=',
            response.data && response.data.success,
            '| workspace_id=',
            response.data && response.data.workspace_id,
            '| error=',
            response.data && response.data.error,
            '| localWId=',
            localStorage.getItem('userCurrentWorkspaceId'),
            '| workspaceUrl=',
            localStorage.getItem('troopr_workspace_id_url'),
          );
          if (response.data.success) {
            window.location.href = '/v2/onboarding';
          } else {
            const slackErr =
              response.data.error === 'slack_already_linked'
                ? 'slack_already_linked'
                : '1';
            window.location.href = `/v2/onboarding?slack_error=${slackErr}`;
          }
          return;
        }
        // A freshly INSTALLED new-UI workspace (generic install, no special
        // state) comes back flagged isNewUi with the cookie session the backend
        // just set. Route it straight into the new-UI onboarding wizard —
        // otherwise the legacy /onBoarding fallback below bounces to /v2 with no
        // session and logs the user out. Guarded to the plain install path so
        // bot-update / appsumo / marketing / jira flows keep their redirects.
        if (
          response.data.success &&
          response.data.isNewUi &&
          response.data.workspace_id &&
          !type &&
          !response.data.isBotUpdate
        ) {
          // The new-UI wizard reads the active workspace from this key — set it
          // before redirecting or /v2/onboarding hangs on "Loading workspace
          // setup…" (mirrors TrooprWorkspaces.startOnboarding).
          localStorage.setItem(
            'userCurrentWorkspaceId',
            response.data.workspace_id
          );
          window.location.href = '/v2/onboarding';
          return;
        }
        if (
          response.data.success &&
          response.data.workspace_id &&
          response.data.isBotUpdate
        ) {
          window.location.href = `/${response.data.workspace_id}/dashboard?botupdate=success`;
          return;
        } else if (
          response.data.success &&
          response.data.workspace_id &&
          response.data.source &&
          (response.data.source === 'appsumo_update' ||
            response.data.source === 'workspace_already_paid')
        ) {
          window.location.href = `/${response.data.workspace_id}/dashboard?source=${response.data.source}`;
          return;
        } else if (
          response.data.success &&
          response.data.workspace_id &&
          response.data.source &&
          response.data.source === 'product_already_subscribed'
        ) {
          window.location.href = `/${response.data.workspace_id}/dashboard?source=${response.data.source}&product=${response.data.product}`;
          return;
        }
        // console.log(response)
        if (response.data.success) {
          // console.log("workspace:", JSON.stringify(response.data))
          // this.props.history.push("/"+response.data.workspace_id+"/onboarding");
          if (
            type == 'jiraslackdotcom_starter' ||
            type == 'jiraslackdotcom_standard' ||
            type == 'jiraslackdotcom_pro' ||
            type == 'jiraslackdotcom_na'
          ) {
            this.props
              .getAssisantSkills(response.data.workspace_id)
              .then((res) => {
                if (res.data.success) {
                  let jiraSkill = res.data.skills.find(
                    (skill) => skill.key == 'jira'
                  );
                  window.location.href =
                    window.location.origin +
                    '/' +
                    response.data.workspace_id +
                    '/skills/' +
                    jiraSkill.skill_metadata._id +
                    '/jira_software';
                } else {
                  this.setState({ errors: response.data.errors });
                  this.props.history.push('/troopr/access');
                }
              });
          } else if (
            type &&
            (type.includes('trooprai-landing') ||
              type.includes('website-standup') ||
              type.includes('website-retro') ||
              type.includes('website-poker') ||
              type.includes('trooprai-teammood') ||
              type.includes('trooprai-pricing') ||
              type.includes('jsi_wiki_na') ||
              type.includes('jsi_na') ||
              type.includes('instant-poker') ||
              type.includes('trooprai-eng') ||
              type.includes('trooprai-it'))
          ) {
            let state = '';
            if (type.includes('trooprai-teammood')) {
              state = 'team_mood';
            } else if (type.includes('instant-poker')) {
              state = 'instant-poker';
            } else if (type.includes('website-retro')) {
              state = 'retro';
            } else if (type.includes('website-poker')) {
              state = 'planning_poker';
            } else if (type.includes('jsi_na')) {
              state = 'jira_slack_int';
            } else if (type.includes('jsi_wiki_na')) {
              state = 'jsi_wiki_na';
            } else if (type.includes('trooprai-eng')) {
              state = 'trooprai-eng';
            } else if (type.includes('trooprai-it')) {
              state = 'trooprai-it';
            } else {
              state = 'checkin';
            }
            //let state = type.includes('trooprai-teammood') ? 'team_mood' : 'checkin'
            let url =
              window.location.origin +
              '/' +
              response.data.workspace_id +
              '/onBoarding/' +
              state;

            if (IsJsonString(params) && JSON.parse(params)) {
              const queryObj = JSON.parse(params);
              Object.entries(queryObj).forEach(([key, value], index) => {
                url += `${index === 0 ? '?' : '&'}${key}=${value}`;
              });
            }
            window.location.href = url;
          } else {
            if (response.data.isNewAuth) {
              this.props
                .getAssisantSkills(response.data.workspace_id)
                .then((res) => {
                  if (res.data.success) {
                    let jiraSkill = res.data.skills.find(
                      (skill) => skill.key == 'jira'
                    );
                    //window.location.href="http://localhost:3000"+"/"+response.data.workspace_id+"/skills/"+jiraSkill.skill_metadata._id+"?view=personal_preferences"
                    if (response.data.isArchiveTokenInfo) {
                      const commonChannelConfig =
                        response.data.channelConfigData;
                      ///jira_software?view=channel_preferences&channel_name=helll&channel_id=C05N1PN33RC&channel_type=project
                      const projectType =
                        commonChannelConfig.channel_type === 'project'
                          ? 'jira_software'
                          : 'jira_service_desk';
                      window.location.href = `${window.location.origin}/${response.data.workspace_id}/skills/${jiraSkill.skill_metadata._id}/${projectType}?view=channel_preferences&channel_name=${commonChannelConfig.channel.name}&channel_id=${commonChannelConfig.channel.id}&channel_type=${commonChannelConfig.channel_type}&isArchiveInfoToken=true&subscription=${response.data.subscriptionId}`;
                    } else {
                      window.location.href =
                        window.location.origin +
                        '/' +
                        response.data.workspace_id +
                        '/skills/' +
                        jiraSkill.skill_metadata._id +
                        '/jira_software?view=personal_preferences';
                    }

                    message.success('Permissions Given Successfully!');
                  } else {
                    this.setState({ errors: response.data.errors });
                    this.props.history.push('/troopr/access');
                  }
                });
            } else {
              /* else if(response.data.source === 'appsumo_install'){
                let product = ''
                let res_product = response.data.product
                if(res_product){
                  if(res_product === 'standups') product = 'checkin'
                  else if (res_product === 'jira_software' || res_product === 'jira_service_desk' || res_product === 'jira_reports' ) product = 'jira_slack_int'
                  else if (res_product === 'wiki' ) product = 'jsi_wiki_na'
                }
                window.location.href="https://"+window.location.hostname+"/"+response.data.workspace_id+"/onBoarding/"+product
              } */
              // if(type && type.includes('botupdate')) {
              //   message.success("Troopr Assistant successfully updated to latest version!")
              //   window.location.href="https://"+window.location.hostname+"/"+response.data.workspace_id+"/dashboard"
              // }
              // else window.location.href="https://"+window.location.hostname+"/"+response.data.workspace_id+"/onBoarding"

              // New-UI workspaces (every fresh Slack install — troopr-api sets
              // isNewUi:true for them) belong in the v2 wizard, NOT this legacy
              // onboarding. The install response tells us which generation the
              // workspace is on (see trooprbot bridgeInstallAuthSession), and
              // auth cookies are already set, so the wizard opens logged in.
              // Installs from the Slack App Directory land here rather than in
              // the `v21_onboarding` branch above, since that only covers a
              // connect the v2 app itself initiated.
              if (response.data.isNewUi && response.data.workspace_id) {
                // The wizard reads the active workspace from this key — set it
                // BEFORE redirecting or /v2/onboarding hangs forever on
                // "Loading workspace setup…" (useTeamSetup early-returns
                // without clearing loadingConnections when wId is missing).
                // Same requirement as the plain-install branch above.
                localStorage.setItem(
                  'userCurrentWorkspaceId',
                  response.data.workspace_id
                );
                window.location.href = '/v2/onboarding';
                return;
              }

              let url =
                window.location.origin +
                '/' +
                response.data.workspace_id +
                '/onBoarding';

              if (IsJsonString(params) && JSON.parse(params)) {
                const queryObj = JSON.parse(params);
                Object.entries(queryObj).forEach(([key, value], index) => {
                  url += `${index === 0 ? '?' : '&'}${key}=${value}`;
                });
              }

              window.location.href = url;
            }
          }
          // this.props.getTourInfo().then(res => {
          //   if (!res.data.success) {
          //     let data = {};
          //     data.type = 'slack';
          //     this.props.createTourInfo(data).then(tour => {
          //       window.location.href="https://"+window.location.hostname+"/"+response.data.workspace_id+"/skills"
          //     })
          //   }else{
          //     window.location.href="https://"+window.location.hostname+"/"+response.data.workspace_id+"/skills";
          //   }
          //   window.location.href = "https://"+window.location.hostname+"/"+response.data.workspace_id+"/onBoarding" ;

          // this.props.createTourInfo(data);

          // if (type == "user_team_link") {
          //   this.props.history.push("/projects/picker");
          // } else if (type == "website-standup") {
          //   // console.log("hello hello heloo")
          //   window.location.href =
          //     "https://app.troopr.io/welcome/" +
          //     response.data.workspace_id +
          //     "?team=" +
          //     response.data.team +
          //     "&type=website-standup";
          // } else {
          //   if (localStorage.troopr_workspace_id_url) {
          //     localStorage.removeItem("troopr_workspace_id_url");
          //     window.location = "https://app.troopr.io" + url;
          //     // this.props.history.push(url);
          //   } else {
          //     // console.log('checking response', response);

          //     window.location.href =
          //       "https://app.troopr.io/welcome/" +
          //       response.data.workspace_id +
          //       "?team=" +
          //       response.data.team;

          //     // console.log(`https://app.troopr.io/slack_landing?team=${response.data.url}`);
          //     // console.log("-----------------From slack auth-----------------",response.data);
          //     // window.location="https://slack.com/app_redirect?app=AE4FF42BA&team="+response.data.team
          //   }
          // }
        } else {
          this.setState({ errors: response.data.errors });
          // console.log('checking access');
          this.props.history.push('/troopr/access');
        }
      })
      .catch((err) => {
        console.error('err-==>', err);
        if (type === 'v21_onboarding') {
          window.location.href = '/v2/onboarding?slack_error=1';
          return;
        }
        this.setState({
          error: err,
        });
      });

    //catch action here and senf hem to access link
  }

  onClickRedirect = () => {
    // this.props.history.push("");

    if (this.state.error === 'error_botupdate')
      window.location.href = 'https://app.troopr.io/slack?source=botupdate';
    else window.location.href = 'https://app.troopr.io/slack';
    //https://app.troopr.io/slack
  };

  render() {
    let errHtml = (
      <div
        style={{ width: '100vw', height: '100vh' }}
        className='d-flex flex-column justify-content-center align-items-center'
      >
        <div>OOPS! Itseems there was an error while installing</div>
        <div
          className='confirmation-button primary_btn btn_114'
          onClick={this.onClickRedirect}
          style={{ padding: '25px', marginTop: '5px' }}
        >
          Click to reinstall
        </div>
      </div>
    );

    const type = queryString.parse(this.props.location.search).state;

    return (
      <div>
        {this.state.error ? (
          errHtml
        ) : (
          <div
            style={{ width: '100vw', height: '100vh' }}
            className='d-flex flex-column justify-content-center align-items-center'
          >
            <div className='loader' />{' '}
            <div style={{ fontSize: '24px', fontWeight: '500' }}>
              {type !== 'OA'
                ? `Please do not refresh the page or hit the back button. The app is
              getting installed.`
                : 'Processing ...'}
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default connect(null, { slackApproval, getAssisantSkills })(SlackAuth);
